
import React from 'react';
import { useArchitectureStore } from '../../store/useArchitectureStore';
import { Sun, Sunset, Moon } from 'lucide-react';

const TimeOfDaySelector: React.FC = () => {
    const { timeOfDay, setTimeOfDay } = useArchitectureStore();

    const options = [
        { id: 'Day', label: 'Day', icon: Sun },
        { id: 'Sunset', label: 'Sunset', icon: Sunset },
        { id: 'Night', label: 'Night', icon: Moon }
    ];

    return (
        <div className="flex bg-stone-900/90 backdrop-blur-md rounded-full shadow-lg border border-stone-800 p-1 mr-4 pointer-events-auto">
            {options.map((option) => (
                <button
                    key={option.id}
                    onClick={() => setTimeOfDay(option.id)}
                    className={`
                        relative flex items-center justify-center w-10 h-10 rounded-full transition-all duration-300 group
                        ${timeOfDay === option.id
                            ? 'bg-stone-800 text-orange-500 shadow-inner'
                            : 'text-stone-500 hover:text-stone-300 hover:bg-stone-800/50'
                        }
                    `}
                    title={option.label}
                >
                    <option.icon size={18} className="relative z-10" />

                    {/* Active Indicator Dot */}
                    {timeOfDay === option.id && (
                        <span className="absolute -bottom-1 w-1 h-1 rounded-full bg-orange-500"></span>
                    )}
                </button>
            ))}
        </div>
    );
};

export default TimeOfDaySelector;
